import React from 'react';
import { Modal } from 'antd';
import Lottie from 'react-lottie';
import { bool, instanceOf } from 'prop-types';
import data from './data';

function RequestSentModal({ toggleModal, connectionData }) {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: data,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return (
    <Modal visible onCancel={toggleModal} closable footer={null} wrapClassName="user-details-modal">
      <Lottie options={defaultOptions} width={152} height={152} isStopped={false} isPaused={false} />
      <h5 className="arc-H250 arc-text-align-c">Connection request sent</h5>
      <p className="arc-color-gray8 arc-p arc-text-align-c">
        You have
        {' '}
        {connectionData?.connections_available}
        {' '}
        connections remaining. You can view your
        <br />
        connections in the connections tab.
      </p>
    </Modal>
  );
}

RequestSentModal.propTypes = {
  toggleModal: bool.isRequired,
  connectionData: instanceOf(Object).isRequired,
};

export default RequestSentModal;
